/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './assets-dashboard.scss';

/* eslint-disable import/no-unresolved, import/default */

import assetsDashboardTemplate from './assets-dashboard.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.assetsDashboard', [])
    .directive('agAssetsDashboard', AssetsDashboard)
    .name;

/*@ngInject*/
function AssetsDashboard() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            hasParentAsset: '=',
            parentAssetId: '=',
            showAeration: '=',
            fetchAssets: '&',
            onAssetSelected: '&'
        },
        controller: AssetsDashboardController,
        controllerAs: 'vm',
        templateUrl: assetsDashboardTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function AssetsDashboardController($rootScope, $scope, $filter, $mdMedia,
                              $translate, agTypes, agUtils, userService, siteService, siloGroupService, siloService) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' ||
        userService.getAuthority() === 'CUSTOMER_USER';
    vm.hasData = false;

    vm.mode = 'site';
    vm.siteAssets = [];
    vm.currentSiteAsset = null;

    vm.onWidgetClick = onWidgetClick;
    vm.isCurrent = isCurrent;

    $scope.$watch(function() { return $mdMedia('gt-xs'); }, function(isGtXs) {
        vm.isGtXs = isGtXs;
    });

    $scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
        vm.isGtMd = isGtMd;
    });

    if (vm.ctx.connectedSystemScope) {
        vm.helpPageAction = agUtils.createHelpActionConfig("agSilo", "ag.docsPageSections.silo-connected-systems");
    } else {
        vm.helpPageAction = agUtils.createHelpActionConfig("agGuiComponents", "ag.docsPageSections.assets-dashboards-view");
    }

    $scope.$watch('vm.ctx', function() {
        if (vm.showData && vm.ctx) {
            if (vm.hasParentAsset) {
                vm.mode === 'site';
            } else {
                vm.mode = angular.isDefined(vm.ctx.settings.mode) ? vm.ctx.settings.mode : 'site';
                $scope.$watch(function () {
                        return vm.ctx.stateController.getStateId();
                    },
                    function (newStateId, prevStateId) {
                        if (newStateId && newStateId !== prevStateId) {
                            if (newStateId === agTypes.clientState.site) {
                                vm.currentSiteAsset = null;
                            }
                        }
                    }
                );
                if (vm.mode === 'sites') {
                    vm.ctx.widgetTitle = $translate.instant('ag.site.sites') + '';
                } else if (vm.mode === 'site') {
                    vm.ctx.widgetTitle = $translate.instant('ag.site.site-assets') + '';
                } else if (vm.mode === 'siloGroup') {
                    vm.ctx.widgetTitle = $translate.instant('ag.silo.silos') + '';
                }
            }
            vm.ctx.widgetActions = [ vm.helpPageAction ];
            vm.clientParentAssetId = null;
            loadClientSiteAssets();
            if (vm.hasParentAsset) {
                $scope.$watch('vm.parentAssetId', (newVal, prevVal) => {
                    if (newVal && !angular.equals(newVal, prevVal)) {
                        loadClientSiteAssets();
                    }
                });
            } else {
                $scope.$watch(() => getClientParentAssetId(), (newVal, prevVal) => {
                    if (newVal && !angular.equals(newVal, prevVal)) {
                        loadClientSiteAssets();
                    }
                });
            }
        }
    });

    function getClientParentAssetId() {
        var targetStateId;
        var stateParams;
        if (vm.mode) {
            if (vm.mode === 'site') {
                targetStateId = agTypes.clientState.site;
            } else if (vm.mode === 'siloGroup') {
                targetStateId = agTypes.clientState.siloGroup;
            }
        }
        if (targetStateId) {
            stateParams = vm.ctx.stateController.getStateParamsByStateId(targetStateId);
        }
        if (stateParams) {
            return stateParams.entityId;
        } else {
            return null;
        }
    }

    function loadClientSiteAssets() {
        vm.clientParentAssetId = getClientParentAssetId();
        var currentSiteAssetId;
        if (vm.ctx.stateController.getStateId() !== agTypes.clientState.site) {
            currentSiteAssetId = vm.ctx.stateController.getStateParams().entityId;
        }
        if (vm.mode === 'sites') {
            currentSiteAssetId = vm.clientParentAssetId;
        }
        reloadSiteAssets(false, true, currentSiteAssetId);
    }

    $scope.$on('alarmsUpdated', function() {
        reloadSiteAssets(true);
    });

    $scope.$on('siteAssetUpdated', function (event, siteAsset) {
        var result = $filter('filter')(vm.siteAssets, {id: { id: siteAsset.id.id } }, true);
        if (result && result.length) {
            var prevSiteAsset = result[0];
            var index = vm.siteAssets.indexOf(prevSiteAsset);
            if (index > -1) {
                vm.siteAssets[index].name = siteAsset.name;
                vm.siteAssets[index].label = siteAsset.label;
                if (siteAsset.type === agTypes.assetType.aeration) {
                    vm.siteAssets[index].aerationType = (siteAsset.aerationType) ? siteAsset.aerationType : agTypes.aerationType.aeration;
                }
            }
        }
    });

    function onWidgetClick($event, asset) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.currentSiteAsset !== asset) {
            vm.currentSiteAsset = asset;
        }
        if (vm.onAssetSelected) {
            vm.onAssetSelected({asset: asset});
        }
    }

    function isCurrent(asset) {
        return (vm.currentSiteAsset && asset) &&
            (vm.currentSiteAsset.id.id === asset.id.id);
    }

    function reloadSiteAssets (keepSelection, skipNotify, currentSiteAssetId) {
        vm.multipleSilosConfig = {
          hasMoistureCables: false,
          hasCO2Cables: false,
          hasLevelIndicator: false,
          hasHeadSpaceSensor: false,
          hasConnectedSystems: false,
          hasNormalAeration: false,
          hasAlarmAeration: false
        };
        vm.siteAssets.length = 0;
        if (!keepSelection) {
            vm.currentSiteAsset = null;
        }
        vm.siteAssetsPromise = null;
        if (vm.hasParentAsset) {
            vm.siteAssetsPromise = vm.fetchAssets({fetchAlarmsSeverity: true});
        } else if (vm.mode === 'sites' || vm.clientParentAssetId) {
            if (vm.mode === 'sites') {
                vm.siteAssetsPromise = siteService.getCustomerSites(true);
            } else if (vm.mode === 'site') {
                vm.siteAssetsPromise = siteService.getSiteAssets(vm.clientParentAssetId, true, agTypes.assetBrowserWidgetType.dashboard);
            } else if (vm.mode === 'siloGroup') {
                vm.siteAssetsPromise = siloGroupService.getSiloGroupAssets(vm.clientParentAssetId, true, agTypes.assetBrowserWidgetType.dashboard);
            }
        }
        if (vm.siteAssetsPromise) {
            vm.siteAssetsPromise.then(
                function success(siteAssets) {
                    vm.siteAssets = $filter('orderBy')(siteAssets, 'name');
                    if (vm.siteAssets.length) {
                        vm.siteAssets.forEach((asset) => {
                            if (asset.type === agTypes.assetType.silo) {
                                if (asset.hasMoistureCables) {
                                    vm.multipleSilosConfig.hasMoistureCables = true;
                                }
                                if (asset.hasCO2Cables) {
                                    vm.multipleSilosConfig.hasCO2Cables = true;
                                }
                                if (asset.hasLevelIndicator) {
                                    vm.multipleSilosConfig.hasLevelIndicator = true;
                                }
                                if (asset.hasHeadSpaceSensor) {
                                    vm.multipleSilosConfig.hasHeadSpaceSensor = true;
                                }

                                siloService.getSiloConnectedSystems(asset.id).then(
                                    function success(connectedSystems) {
                                        asset.hasConnectedSystems = connectedSystems && connectedSystems.length > 0;
                                        asset.connectedSystems = connectedSystems;
                                        asset.hasNormalAeration = false;
                                        asset.hasAlarmAeration = false;

                                        connectedSystems.forEach(aeration => {
                                            if (aeration.aerationType === agTypes.aerationType.alarm) {
                                                asset.hasAlarmAeration = true;
                                            } else {
                                                asset.hasNormalAeration = true;
                                            }
                                        })

                                        if (asset.hasConnectedSystems) {
                                            vm.multipleSilosConfig.hasConnectedSystems = true;
                                        }
                                        if (asset.hasNormalAeration) {
                                            vm.multipleSilosConfig.hasNormalAeration = true;
                                        }
                                        if (asset.hasAlarmAeration) {
                                            vm.multipleSilosConfig.hasAlarmAeration = true;
                                        }
                                    },
                                    function fail() {
                                    }
                                );
                            }
                        });
                    }
                    if (currentSiteAssetId) {
                        var result = $filter('filter')(vm.siteAssets, {id: {id: currentSiteAssetId.id}}, true);
                        if (result && result.length) {
                            vm.currentSiteAsset = result[0];
                        }
                    }
                    vm.siteAssetsPromise = null;
                },
                function fail() {
                    vm.siteAssets = [];
                    vm.siteAssetsPromise = null;
                }
            )
        } else {
            vm.siteAssets = [];
        }
        if (!skipNotify) {
            $rootScope.$broadcast('siteAssetsListUpdated', vm.clientParentAssetId, keepSelection);
        }
    }
}
